import { Button, Loader, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { RichTextEditor } from "@mantine/tiptap";
import { Content } from "@tiptap/core";
import { useEditor } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";

import { useWindowLocationHost } from "@/hooks";
import { useGetCompanyByHostQuery, useGetTermsUserByCompanyQuery } from "@/store";

export type TermsModalProps = {
  title: string;
  terms: Content;
};
export function TermsModal({ context, id /* innerProps: { terms, title } */ }: ContextModalProps<TermsModalProps>) {
  const { windowLocationHost } = useWindowLocationHost();

  const { data: company, isSuccess } = useGetCompanyByHostQuery({ host: windowLocationHost }, { skip: !windowLocationHost });
  const { data, isLoading } = useGetTermsUserByCompanyQuery({ id: isSuccess ? company.id : 0 }, { skip: !isSuccess });

  const editor = useEditor(
    {
      content: data?.content,
      extensions: [StarterKit],
      editable: false
    },
    [isLoading]
  );

  return (
    <>
      <Title className="mb-2 text-center text-2xl font-bold text-black">{data?.title}</Title>

      {!isLoading && (
        <RichTextEditor editor={editor}>
          <RichTextEditor.Content />
        </RichTextEditor>
      )}

      {isLoading && (
        <div className="my-4 flex items-center justify-center">
          <Loader size="xl" />
        </div>
      )}

      <Button onClick={() => context.closeModal(id)} color="primary" size="md" mt="md" fullWidth>
        Fechar
      </Button>
    </>
  );
}
